import { connect } from 'react-redux';
import { compose, withHandlers, branch, renderComponent, renderNothing, withState } from 'recompose';
import { t } from '../../../../../modules/infra/i18n';

import WaiverButton from '../components/WaiverButton';
import WaiverViewLink from '../components/WaiverViewLink';
import { sendWaiver } from '../../actions';
import { getActiveShop, getShopById } from '../../../../auth/selectors';
import withNotifications from '../../../../common/withNotifications';

export default compose(
  connect(
    (state, ownProps) => ({
      shop: getActiveShop(state) || getShopById(state, ownProps.appointment.shopId) || {},
    }),
    { sendWaiver }
  ),
  branch(({ shop, appointment: appt }) => !shop.requiresWaiver || (appt.waiver && !appt.waiverViewLink), renderNothing),
  branch(
    ({ shop, appointment: appt }) => shop.requiresWaiver && appt.waiver && appt.waiverViewLink,
    renderComponent(WaiverViewLink)
  ),
  withNotifications,
  withState('busy', 'setBusy', false),
  withHandlers({
    onClick: (props) => async () => {
      props.setBusy(true);
      try {
        await props.sendWaiver(props.appointment.id);
        props.setBusy(false);
        props.addNotification({
          title: t('common:notifications.success_title_alt'),
          level: 'success',
          message: t('appointment:waiver.notification_sent'),
        });
      } catch (e) {
        props.setBusy(false);
      }
    },
  })
)(WaiverButton);
